import { SET_MASTER_MENU } from "../../../constants/types";

const initialState = {
  masterMenu: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_MASTER_MENU:
      return {
        ...state,
        masterMenu: payload,
      };
    default:
      return state;
  }
}
